import React from 'react';

import {
  apolloService,
  authService,
  enumCache
} from 'modules';

import { createRoot } from 'react-dom/client';
import App from './App';

import './index.css';



async function __init() {
  await authService.init();

  apolloService.getClientObservable()
    .subscribe(client => {
      enumCache.init(client);
    });

  const container = document.getElementById('root');
  if (container) {
    const isProd = process.env['REACT_APP_ENV_NAME'] === 'prod';
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />

        {!isProd && (
          <div style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            height: '16px',
            fontSize: '12px',
            backgroundColor: '#f44336',
            textAlign: 'center',
            color: 'white',
            fontWeight: 'bold',
            pointerEvents: 'none'
          }}>
            THIS IS NOT A PRODUCTION ENVIRONMENT. DO NOT USE PRODUCTION CREDENTIALS HERE.
          </div>
        )}
      </React.StrictMode>
    );
  }
}

__init();
